import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./components/Header/styles/Header.css";
import "./tailwind.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GlobalContextProvider } from "./context/GlobalContext";
import zipy from 'zipyai';
zipy.init("784f2aee", {
  rootDomain: 'programmingpathshala.com'
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <GlobalContextProvider>
        <App />
    </GlobalContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
